import {inject, ref} from 'vue';

export default {
    install: (app, options) => {
        const editors = {
            'company_profile': ['configurator_super_user_admin', 'configurator_administrator'],
            // 'products_actions': ['configurator_super_user_admin'],
            'products_actions': [],
            'products_prices_actions': ['configurator_super_user_admin', 'configurator_super_user', 'configurator_administrator', 'configurator_user'],
            // 'materials_actions': ['configurator_super_user_admin'],
            'materials_actions': [],
            'materials_prices_actions': ['configurator_super_user_admin', 'configurator_super_user'],
        };

        const availablePathsForCompany = {
            '/dashboard/companies': ['manufacturer'],
            '/dashboard/users': ['distributor', 'dealer', 'manufacturer'],
            '/dashboard/network/dealers': ['distributor'],
            '/dashboard/subscription-and-billing': ['distributor', 'dealer', 'manufacturer'],
            '/dashboard/seats': ['distributor', 'dealer', 'manufacturer'],
            '/dashboard/faq': ['manufacturer', 'distributor', 'dealer'],
        };

        const availablePathsForUser = {
            '/dashboard/companies': ['configurator_super_user_admin', 'configurator_super_user'],
            '/dashboard/users': ['configurator_administrator', 'configurator_super_user_admin'],
            '/dashboard/network/dealers': ['configurator_administrator', 'configurator_user'],
            '/dashboard/subscription-and-billing': ['configurator_administrator', 'configurator_super_user_admin'],
            '/dashboard/seats': ['configurator_administrator', 'configurator_super_user_admin'],
            '/dashboard/faq': ['configurator_super_user_admin', 'configurator_super_user', 'configurator_administrator', 'configurator_user'],
        };

        const page = (path) => {
            const company = inject('profileCompany');
            const user = inject('profileUser');

            const types = availablePathsForCompany[path];
            const roles = availablePathsForUser[path];

            if (types && company.value && company.value && roles && user.value && user.value) {
                return types.includes(company.value.type.key) && roles.includes(user.value.role.key);
            }

            return false;
        };

        const editor = (editor) => {
            let roles = editors[editor];
            const user = inject('profileUser');

            if (user.value && roles) {
                return roles.includes(user.value.role.key);
            }

            return false;
        };


        app.provide('accessPage', page);
        app.provide('accessEditor', editor);
    },
}
